import { useNavigate } from "react-router-dom";
import "../../styles/auth/auth.css";

const ForgotPassword = (props = {}) => {
  const { loading } = props;
  const navigate = useNavigate();

  const forgotPasswordHandler = (event) => {
    event.preventDefault();
    navigate("/reset-password");
  };

  return (
    <div className="forgot-password-container">
      <button
        type="button"
        className="forgot-password"
        disabled={loading}
        onClick={forgotPasswordHandler}
      >
        Forgot Password?
      </button>
    </div>
  );
};

export default ForgotPassword;
